import { useDisplay } from 'vuetify';
import { feedService } from '@/services/feedService';
import { BettingDataFactory } from '@/models/bettingDataFactory';
import { useAppStore } from '@/stores/app';
import { EventMarketTypes } from '@/types/event';
import { useBetDialogsRefs } from '@/composables/useBetDialogRef';

export function usePriceHandler() {
    const betDialogsRefs = useBetDialogsRefs();
    const { xs } = useDisplay();
    const appStore = useAppStore();

    const onPriceClick = (market: EventMarketTypes, periodId: number, betSelectionId: number): void => {
        let keys = Object.keys(appStore.betFeedData);

        // max count of allowed dialogs
        if (keys.length >= 4) {
            return;
        }

        let idx: number | undefined = 1;

        if (keys.length > 0) {
            idx = Array.from({ length: 5 }, (_, i) => i + 1).find((num) => !keys.includes(String(num)));
        }

        console.log('Idx will be used for new bet dialog: %s', [idx]);

        if (idx === undefined) {
            return;
        }

        appStore.betFeedData[idx] = BettingDataFactory.createFromEvent(market, periodId, betSelectionId);

        let ref = 'betDialog' + idx;

        if (betDialogsRefs) {
            feedService.wsSubscribe();
            betDialogsRefs[ref].open(!xs.value);
        }
    };

    return {
        onPriceClick,
    };
}
